import React, { Component } from 'react';
import { IconButton } from '@mui/material';
import Typography from '../../../../component/Typography';
import withStyles from '@mui/styles/withStyles';
import TableData from '../../../../component/form/TableData';
import { VALUABLES_LOCATION_OPTIONS, VALUABLES_RETURN_OPTIONS } from './ValuablesConstants';
import Select from '../../../../component/form/Select';
import Checkbox from '../../../../component/form/Checkbox';
import EditIcon from '../../../../component/icon/EditIcon';
import TextField from '../../../../component/form/TextField';
import DeleteIcon from '../../../../component/icon/DeleteIcon';

class ValuablesModalListTab extends Component {
    render() {
        const { classes, form } = this.props;
        const data = form.getField('valuableItems') || {};
        const countR = Object.keys(data).length;
        const s = 1 === countR;
        return (
            <div className={classes.root}>
                <div className={classes.modalHeader}>
                    <Typography variant="title" className={classes.title}>
                        {countR} Documented Valuable{!s && 's'}:
                        {/*<PrimaryButton style={{ float: 'right' }} onClick={e => this.props.onEditRecord('0')}>*/}
                        {/*    + Add Valuable*/}
                        {/*</PrimaryButton>*/}
                    </Typography>
                </div>
                <div style={{ clear: 'both' }} />
                {this.renderTemplateList()}
            </div>
        );
    }

    renderTemplateList() {
        const { classes, form, disabled } = this.props;
        const data = form.getField('valuableItems') || {};
        const tableData = Object.values(data);

        return (
            <div className={classes.dataList}>
                <TableData
                    columns={[
                        {
                            id: 'Description',
                            label: 'Description',
                            render: (val, row) => (
                                <>
                                    <strong>{val}</strong>
                                    <small>
                                        <br />
                                        {row.Note}
                                    </small>
                                </>
                            )
                        },
                        { id: 'Quantity', label: 'Qty', render: val => <>x{val}</> },
                        {
                            id: 'FinalAction',
                            label: 'Final Action',
                            render: val => <>{VALUABLES_RETURN_OPTIONS.find(obj => val === obj.value).label}</>
                        },
                        {
                            id: 'Signed',
                            label: 'Form Signed',
                            render: (val, row) => {
                                const isDisabled =
                                    !row.CurrentLocation || row.CurrentLocation === 'Awaiting Delivery' || disabled;
                                return (
                                    <Checkbox
                                        name={'valuableItems.id' + row.ID + '.Signed'}
                                        title={`Item is ${val ? '' : 'not '}signed on Valuables Form`}
                                        form={form}
                                        disabled={isDisabled}
                                    />
                                );
                            },
                            styles: { width: 1 }
                        },
                        {
                            id: 'CurrentLocation',
                            label: 'Current Status',
                            render: (val, row) => {
                                return (
                                    <div>
                                        <Select
                                            name={'valuableItems.id' + row.ID + '.CurrentLocation'}
                                            form={form}
                                            options={VALUABLES_LOCATION_OPTIONS}
                                            disabled={disabled}
                                            allowNone={false}
                                        />
                                        <br />
                                        <TextField
                                            name={'valuableItems.id' + row.ID + '.CurrentLocationDetail'}
                                            form={form}
                                            placeholder="Where?"
                                            disabled={disabled}
                                        />
                                    </div>
                                );
                            },
                            styles: { minWidth: '200px' }
                        },
                        {
                            id: 'EditButton',
                            label: '',
                            render: (val, row) => {
                                return (
                                    <div style={{ whiteSpace: 'nowrap' }}>
                                        <IconButton
                                            className={classes.iconButton}
                                            disabled={row.Signed || disabled}
                                            title={'Edit Valuable'}
                                            onClick={() => {
                                                this.props.onEditRecord(row.ID);
                                            }}
                                            size="large"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton
                                            className={classes.iconButton}
                                            disabled={row.Signed || disabled}
                                            title={'Delete Valuable'}
                                            onClick={() => {
                                                this.props.onDeleteRecord(row.ID);
                                            }}
                                            size="large"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </div>
                                );
                            }
                        }
                    ]}
                    data={tableData}
                />
            </div>
        );
    }
}

const styles = ({ palette, typography, breakpoints }) => ({
    root: {
        maxHeight: 'calc(100vh - 375px)',
        width: 800,
        maxWidth: '95vw',
        overflow: 'auto',
        padding: 42,
        marginBottom: '1rem',
        [breakpoints.down('sm')]: {
            maxHeight: 'calc(100vh - 175px)',
            padding: 12
        }
    },
    dataList: {
        overflowY: 'auto',
        marginTop: '20px',
        '& small': {
            whiteSpace: 'pre-line'
        }
    },
    svgLabel: {
        marginLeft: 6,
        [breakpoints.down('sm')]: {
            display: 'none'
        }
    }
});

export default withStyles(styles)(ValuablesModalListTab);
